import React from "react";
import "./Mail.css";

function Mail(props) {
  const { className } = props;

  return (
    <div className={`mail ${className || ""}`}>
      <div className="overlap-group1-8">
        <img className="vector-33" src="/img/vector-19@2x.png" />
      </div>
    </div>
  );
}

export default Mail;
